import { NgModule, Provider } from '@angular/core';
import { ClearInvalidAutocompleteDirective } from '@ird/ng-base';
import { TranslateModule } from '@ngx-translate/core';
import {
  ColorPickerComponent,
  ColorPickerInputComponent,
  CopyContentButtonComponent,
  DeviceDetailTitleComponent,
  DeviceIconsComponent,
  DeviceImageComponent,
  ExportCSVSnackbarComponent,
  FileUploaderComponent,
  GenericAdminPageComponent,
  GenericEditDialogComponent,
  IconPickerComponent,
  ImageComponent,
  ImageSliderComponent,
  MetadataComponent,
  ModelAutocompleteComponent,
  OverlayButtonComponent,
  PasswordInputComponent,
  PermissionOverlayComponent,
  PlaceholderImageComponent,
  SearchBarComponent,
  SearchOptionDirective,
  TableIconComponent,
  TreePathBreadcrumpsComponent,
  UploadDialogComponent,
  WarningPanelComponent,
} from './components';
import { GenericTableComponent } from './components/generic-table/generic-table.component';
import {
  DragAndDropFileDirective,
  ImpersonateDirective,
  NavTabDirective,
  OnlyNumberDirective,
  PreventDefaultDirective,
  StopPropagationDirective,
} from './directives';
import { MaterialModule } from './material.module';
import {
  AllowedPipe,
  ArrayJoinPipePipe,
  LanguageCodePipe,
  MatchCypressPipe,
  SpxDataConversionLabelPipe,
  SpxDataConversionPipe,
} from './pipes';
import {
  ActionsHttpRepository,
  DataConversionRepositoryHttp,
  DeviceConfigRepositoryHttp,
  DeviceModelRepositoryHttp,
  DeviceRepositoryHttp,
  DeviceViewConfigRepositoryHttp,
  FileRepository,
  LoginRepositoryHttp,
  MaintenanceReportRepositoryHttp,
  TenantRepositoryHttp,
  TenantSettingsRepositoryHttp,
  UserRepositoryHttp,
} from './repositories';
import { UnleashRepositoryHttp } from './repositories/unleash.repository.http';
import { BrandsDefaultImagesService, GenericAdminService, ValidatorService } from './services';

/**
 * @deprecated Please use the standalone components of this library instead of pulling all components with this module
 */
@NgModule({
  declarations: [],
  imports: [
    ClearInvalidAutocompleteDirective,
    ColorPickerComponent,
    ColorPickerInputComponent,
    CopyContentButtonComponent,
    DeviceDetailTitleComponent,
    DeviceIconsComponent,
    MetadataComponent,
    NavTabDirective,
    UploadDialogComponent,
    FileUploaderComponent,
    DragAndDropFileDirective,
    SearchBarComponent,
    SearchOptionDirective,
    OverlayButtonComponent,
    PermissionOverlayComponent,
    AllowedPipe,
    PasswordInputComponent,
    WarningPanelComponent,
    DeviceImageComponent,
    ArrayJoinPipePipe,
    ModelAutocompleteComponent,
    ImpersonateDirective,
    TreePathBreadcrumpsComponent,
    ImageSliderComponent,
    ExportCSVSnackbarComponent,
    PlaceholderImageComponent,
    IconPickerComponent,
    PlaceholderImageComponent,
    GenericAdminPageComponent,
    GenericEditDialogComponent,
    GenericTableComponent,
    TableIconComponent,
    LanguageCodePipe,
    MatchCypressPipe,
    SpxDataConversionPipe,
    SpxDataConversionLabelPipe,
    ImageComponent,
    OnlyNumberDirective,
    PreventDefaultDirective,
    StopPropagationDirective,
  ],
  exports: [
    MaterialModule,
    MetadataComponent,
    NavTabDirective,
    UploadDialogComponent,
    FileUploaderComponent,
    DragAndDropFileDirective,
    SearchBarComponent,
    SearchOptionDirective,
    OverlayButtonComponent,
    PermissionOverlayComponent,
    AllowedPipe,
    PasswordInputComponent,
    WarningPanelComponent,
    DeviceDetailTitleComponent,
    TranslateModule,
    DeviceImageComponent,
    MatchCypressPipe,
    ArrayJoinPipePipe,
    ModelAutocompleteComponent,
    DeviceIconsComponent,
    ImpersonateDirective,
    CopyContentButtonComponent,
    TreePathBreadcrumpsComponent,
    ImageSliderComponent,
    ExportCSVSnackbarComponent,
    ColorPickerComponent,
    ColorPickerInputComponent,
    IconPickerComponent,
    GenericAdminPageComponent,
    LanguageCodePipe,
    ImageComponent,
    OnlyNumberDirective,
    PreventDefaultDirective,
    StopPropagationDirective,
  ],
  providers: [provideCommonConfig()],
})
export class SharedDomainNgModule {}

/**
 * Provides common config
 */
export function provideCommonConfig(): Provider[] {
  return [
    AllowedPipe,
    FileRepository,
    ActionsHttpRepository,
    DeviceConfigRepositoryHttp,
    DeviceModelRepositoryHttp,
    DeviceViewConfigRepositoryHttp,
    DeviceRepositoryHttp,
    LoginRepositoryHttp,
    TenantSettingsRepositoryHttp,
    TenantRepositoryHttp,
    UserRepositoryHttp,
    DataConversionRepositoryHttp,
    MaintenanceReportRepositoryHttp,
    GenericAdminService,
    ValidatorService,
    LanguageCodePipe,
    BrandsDefaultImagesService,
    UnleashRepositoryHttp,
  ];
}
